/**
 * Seller inbox API client (2026-11-04) — EtechBackend /mail/* (controllars/SellerMailController.js),
 * same functions and response shapes as etechmail.com/admin/src/services/emailService.js so the
 * ported Inbox works unchanged. myAxios adds the seller's login token.
 */
import myAxios from '../AxiosUrl';
import { URL as BASEURL } from '../AxiosUrlGlobal';

const unwrap = async (p) => {
    try {
        return (await p).data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
const form = (fields, attachments) => {
    const fd = new FormData();
    Object.entries(fields).forEach(([k, v]) => {
        if (v === undefined || v === null || v === '') return;
        fd.append(k, typeof v === 'object' ? JSON.stringify(v) : String(v));
    });
    (attachments || []).forEach((f) => fd.append('attachments', f));
    return fd;
};

export const getEmailAccounts = () => unwrap(myAxios.get('mail/accounts'));
export const getThreadEmails = (threadId, params = {}) => unwrap(myAxios.get('mail/emails', { params: { threadId, limit: 100, ...params } }));
export const threadAction = (threadId, action, extra = {}) => unwrap(myAxios.put(`mail/emails/thread/${encodeURIComponent(threadId)}`, { action, ...extra }));
export const getEmails = (params = {}) => unwrap(myAxios.get('mail/emails', { params }));
export const getEmailById = (emailId) => unwrap(myAxios.get(`mail/emails/${emailId}`));
export const sendEmail = (d) =>
    unwrap(
        myAxios.post(
            'mail/emails/send',
            form({ emailAccountId: d.emailAccountId, to: d.to, cc: d.cc, bcc: d.bcc, subject: d.subject || '', text: d.text || '', html: d.html || '', inReplyTo: d.inReplyTo, references: d.references, threadId: d.threadId, draftId: d.draftId }, d.attachments)
        )
    );
export const replyToEmail = (d) =>
    unwrap(myAxios.post('mail/emails/reply', form({ emailId: d.emailId, emailAccountId: d.emailAccountId, text: d.text || '', html: d.html || '', replyAll: d.replyAll ? 'true' : '' }, d.attachments)));
export const updateEmail = (emailId, data) => unwrap(myAxios.put(`mail/emails/${emailId}`, data));
export const retryDelivery = async () => ({ success: false, error: 'This message was not sent — write it again.' });
export const bulkUpdateEmails = (emailIds, data) => unwrap(myAxios.put('mail/emails/bulk/update', { emailIds, ...data }));
export const deleteEmail = (emailId, permanent = false) => unwrap(myAxios.delete(`mail/emails/${emailId}`, { params: { permanent } }));
export const bulkDeleteEmails = ({ emailAccountId, folder, permanent = false }) => unwrap(myAxios.delete('mail/emails/bulk', { data: { emailAccountId, folder, permanent } }));
export const getEmailCounts = (params = {}) => unwrap(myAxios.get('mail/emails/counts', { params }));
export const createDraft = (data) => unwrap(myAxios.post('mail/emails/draft', data));
export const updateDraft = (draftId, data) => unwrap(myAxios.put(`mail/emails/draft/${draftId}`, data));
export const discardDraft = (draftId) => unwrap(myAxios.delete(`mail/emails/draft/${draftId}`));
export const forwardEmail = (data) => unwrap(myAxios.post('mail/emails/forward', data));

/** Download an attachment (the API needs the login token, so fetch it as a blob and save it). */
export const downloadAttachment = async (emailId, index, filename) => {
    try {
        const res = await myAxios.get(`mail/emails/${emailId}/attachments/${index}`, { responseType: 'blob' });
        const url = URL.createObjectURL(res.data);
        const a = document.createElement('a');
        a.href = url;
        a.setAttribute('download', filename || 'attachment');
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(url), 2000);
    } catch (e) {
        alert('Could not download the attachment');
    }
};
export const API_BASE = BASEURL;
